(function () {
  'use strict';

  /* ---------- Client-side product grid pagination (20 per page) ----------
     Collection grids fetch up to 250 products in one go (see main-collection.liquid), so large
     collections need paging in the browser rather than via Shopify's native page-by-page
     {% paginate %} links, which only kick in past 250 items. Runs on every .product-grid; does
     nothing if a grid has 20 or fewer cards, so it's safe on small grids (New Arrivals, Shop the
     Post, etc.) too. ---------- */
  document.querySelectorAll('.product-grid').forEach(function (grid) {
    var PAGE_SIZE = 20;
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList.contains('product-card');
    });
    if (cards.length <= PAGE_SIZE) return;

    var totalPages = Math.ceil(cards.length / PAGE_SIZE);
    var currentPage = 1;

    var nav = document.createElement('nav');
    nav.className = 'pagination';
    nav.setAttribute('aria-label', 'Pagination');
    grid.insertAdjacentElement('afterend', nav);

    function goToPage(page) {
      currentPage = page;
      renderPage();
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderPage() {
      cards.forEach(function (card, i) {
        card.hidden = Math.floor(i / PAGE_SIZE) + 1 !== currentPage;
      });

      nav.innerHTML = '';

      if (currentPage > 1) {
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.textContent = '← Previous';
        prev.addEventListener('click', function () { goToPage(currentPage - 1); });
        nav.appendChild(prev);
      }

      for (var p = 1; p <= totalPages; p++) {
        if (p === currentPage) {
          var current = document.createElement('span');
          current.setAttribute('aria-current', 'page');
          current.textContent = String(p);
          nav.appendChild(current);
        } else {
          var pageBtn = document.createElement('button');
          pageBtn.type = 'button';
          pageBtn.textContent = String(p);
          (function (target) {
            pageBtn.addEventListener('click', function () { goToPage(target); });
          })(p);
          nav.appendChild(pageBtn);
        }
      }

      if (currentPage < totalPages) {
        var next = document.createElement('button');
        next.type = 'button';
        next.textContent = 'Next →';
        next.addEventListener('click', function () { goToPage(currentPage + 1); });
        nav.appendChild(next);
      }
    }

    renderPage();
  });

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = !mobileNav.hidden;
      mobileNav.hidden = isOpen;
      navToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------- Product gallery: thumbnails, prev/next arrows, and touch swipe ---------- */
  document.querySelectorAll('.product__media').forEach(function (media) {
    var mainWrap = media.querySelector('.product__media-main');
    var mainImg = media.querySelector('[data-product-main-image]');
    var thumbs = media.querySelectorAll('[data-product-thumb]');
    if (!mainWrap || !mainImg || thumbs.length === 0) return;

    var images = Array.prototype.map.call(thumbs, function (t) { return t.getAttribute('data-full'); });
    var index = 0;

    function setActive(i) {
      index = (i + images.length) % images.length;
      // The main image has srcset/sizes for responsive loading; browsers ignore a JS-set
      // .src while srcset is present, so it must be cleared for the swap to actually show.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = images[index];
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === index); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActive(i); });
    });
    thumbs[0].classList.add('is-active');

    if (thumbs.length > 1) {
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'product__media-nav product__media-nav--prev';
      prevBtn.setAttribute('aria-label', 'Previous photo');
      prevBtn.innerHTML = '&larr;';
      prevBtn.addEventListener('click', function () { setActive(index - 1); });

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'product__media-nav product__media-nav--next';
      nextBtn.setAttribute('aria-label', 'Next photo');
      nextBtn.innerHTML = '&rarr;';
      nextBtn.addEventListener('click', function () { setActive(index + 1); });

      mainWrap.appendChild(prevBtn);
      mainWrap.appendChild(nextBtn);

      var startX = null;
      mainWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) { setActive(delta < 0 ? index + 1 : index - 1); }
        startX = null;
      }, { passive: true });
    }
  });

  /* ---------- Modals (quote / memo request) ---------- */
  var quoteModal = document.getElementById('quote-request-modal');

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-quote-modal]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var productField = quoteModal && quoteModal.querySelector('input[name="contact[Product]"]');
      var productInput = quoteModal && quoteModal.querySelector('input[name="contact[Product of interest]"]');
      var title = btn.dataset.productTitle || '';
      if (productField) productField.value = title;
      if (productInput) productInput.value = title;
      openModal(quoteModal);
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeModal(el.closest('.modal'));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal').forEach(function (m) { closeModal(m); });
    }
  });

  /* ---------- Delete confirmation on saved addresses ---------- */
  document.querySelectorAll('[data-confirm-delete]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!window.confirm('Remove this address?')) e.preventDefault();
    });
  });

  /* ---------- Add to cart (memo samples + yardage) via AJAX Cart API ---------- */
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
    });
  }

  document.querySelectorAll('[data-add-variant]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = button.getAttribute('data-add-variant');
      var block = button.closest('.product-form__block');
      var qtyInput = block ? block.querySelector('[data-quantity-input]') : null;
      var minQty = qtyInput ? parseInt(qtyInput.getAttribute('min'), 10) || 1 : 1;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || minQty : 1;
      if (quantity < minQty) {
        quantity = minQty;
        if (qtyInput) qtyInput.value = minQty;
      }

      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          button.textContent = (err && err.description) || 'Couldn’t add — try again';
          button.disabled = false;
          setTimeout(function () { button.textContent = originalText; }, 2500);
        });
    });
  });

  /* ---------- Generic product variant picker (used by Accessories and multi-length Fabric) ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (wrap) {
    var section = wrap.closest('[data-product-section]');
    if (!section) return;

    var variantsEl = section.querySelector('script[data-variant-json]');
    var pricesEl = section.querySelector('script[data-variant-prices-json]');
    var imagesEl = section.querySelector('script[data-variant-images-json]');
    if (!variantsEl || !pricesEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var prices = JSON.parse(pricesEl.textContent);
    var images = imagesEl ? JSON.parse(imagesEl.textContent) : [];
    var selects = wrap.querySelectorAll('[data-variant-option-index]');
    var variantIdInput = section.querySelector('[data-variant-id-input]');
    var addBtn = section.querySelector('[data-variant-add-btn]');
    var priceEl = section.querySelector('[data-variant-price]');
    var availabilityEl = section.querySelector('[data-variant-availability]');
    var mainImageEl = section.querySelector('[data-product-main-image]');
    var shipMessage = wrap.getAttribute('data-ship-message') || 'In stock, ships within 1–3 business days.';

    function selectedOptions() {
      var values = [];
      selects.forEach(function (select) {
        values[parseInt(select.getAttribute('data-variant-option-index'), 10)] = select.value;
      });
      return values;
    }

    function matchVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        var isMatch = opts.every(function (o, idx) { return o === values[idx]; });
        if (isMatch) return { variant: v, price: prices[i], image: images[i] };
      }
      return null;
    }

    function update() {
      var match = matchVariant(selectedOptions());
      if (!match) return;
      var variant = match.variant;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = match.price;
      if (addBtn) {
        addBtn.setAttribute('data-add-variant', variant.id);
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? shipMessage : 'Currently unavailable.';
      }
      if (mainImageEl && match.image) {
        mainImageEl.src = match.image;
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', update);
    });
  });

  /* ---------- Related products (native Shopify recommendations) ---------- */
  document.querySelectorAll('[data-related-products]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-related-products]');
        if (newContent && newContent.querySelector('.product-grid')) {
          el.innerHTML = newContent.innerHTML;
        } else {
          el.remove();
        }
      })
      .catch(function () { el.remove(); });
  });

  /* ---------- Recently viewed (localStorage, no native Shopify API for this) ---------- */
  (function () {
    var STORAGE_KEY = 'callista_recently_viewed';
    var MAX_ITEMS = 8;
    var SHOW_COUNT = 4;

    function getViewed() {
      try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    }
    function saveViewed(list) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }
    function formatMoney(cents, format) {
      var amount = (cents / 100);
      var value = format.indexOf('amount_no_decimals') > -1
        ? Math.round(amount).toString()
        : amount.toFixed(2);
      return format.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, value);
    }

    var section = document.querySelector('[data-recently-viewed]');
    var currentHandle = section ? section.getAttribute('data-current-handle') : null;

    if (currentHandle) {
      var viewed = getViewed().filter(function (h) { return h !== currentHandle; });
      viewed.unshift(currentHandle);
      saveViewed(viewed.slice(0, MAX_ITEMS));
    }

    if (!section) return;
    var grid = section.querySelector('[data-recently-viewed-grid]');
    var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';
    var toShow = getViewed().filter(function (h) { return h !== currentHandle; }).slice(0, SHOW_COUNT);
    if (!grid || toShow.length === 0) return;

    Promise.all(toShow.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p) {
        if (!p) return;
        var image = p.featured_image || (p.images && p.images[0]) || '';
        var title = (p.title || '').replace(/"/g, '&quot;');
        html +=
          '<div class="product-card">' +
            '<div class="product-card__media-wrap">' +
              '<a href="' + p.url + '" class="product-card__media-link">' +
                '<div class="product-card__media">' +
                  (image
                    ? '<img class="product-card__media-img product-card__media-img--primary" src="' + image + '" alt="' + title + '" loading="lazy">'
                    : '<div class="product-card__media--placeholder weave-1"></div>') +
                '</div>' +
              '</a>' +
            '</div>' +
            '<div class="product-card__body">' +
              '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
              '<div class="price-block"><span class="price-block__retail">' + formatMoney(p.price, moneyFormat) + '</span></div>' +
            '</div>' +
          '</div>';
      });
      if (html) {
        grid.innerHTML = html;
        section.hidden = false;
      }
    });
  })();

  /* ---------- Collection type/sample filter (Fabrics & Wallpapers combined collection) ---------- */
  document.querySelectorAll('.collection__filters').forEach(function (bar) {
    var section = bar.closest('section');
    var grid = section ? section.querySelector('.product-grid') : null;
    if (!grid) return;
    var cards = grid.querySelectorAll('.product-card');
    var buttons = bar.querySelectorAll('.collection__filter');

    function applyFilter(type, mode) {
      var isSample = mode === 'sample';
      grid.classList.toggle('is-sample-mode', isSample);
      cards.forEach(function (card) {
        var matchesType = type === 'all' || card.getAttribute('data-product-type') === type;
        card.hidden = !matchesType;

        // In sample mode, point the card at its standalone sample product page (if one is
        // linked via the trade.sample_product metafield) instead of the full product page.
        var defaultUrl = card.getAttribute('data-default-url');
        var sampleUrl = card.getAttribute('data-sample-url');
        if (defaultUrl) {
          var targetUrl = (isSample && sampleUrl) ? sampleUrl : defaultUrl;
          card.querySelectorAll('[data-card-link]').forEach(function (link) {
            link.setAttribute('href', targetUrl);
          });
        }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        applyFilter(btn.getAttribute('data-filter-type'), btn.getAttribute('data-filter-mode'));
      });
    });
  });

  /* ---------- Wall area calculator (recommends rolls needed, reuses the existing roll
     add-to-cart button/quantity input rather than its own cart logic) ---------- */
  document.querySelectorAll('[data-wall-calc]').forEach(function (calc) {
    var toggleBtn = calc.querySelector('[data-wall-calc-toggle]');
    var panel = calc.querySelector('[data-wall-calc-panel]');
    var unitButtons = calc.querySelectorAll('[data-wall-calc-unit]');
    var widthInput = calc.querySelector('[data-wall-calc-width]');
    var heightInput = calc.querySelector('[data-wall-calc-height]');
    var calculateBtn = calc.querySelector('[data-wall-calc-calculate]');
    var resultEl = calc.querySelector('[data-wall-calc-result]');
    var countEl = calc.querySelector('[data-wall-calc-count]');
    var sizeEl = calc.querySelector('[data-wall-calc-size]');
    var priceEl = calc.querySelector('[data-wall-calc-price]');
    var addBtn = calc.querySelector('[data-wall-calc-add]');

    var rollWidthCm = parseFloat(calc.getAttribute('data-roll-width-cm'));
    var rollLengthCm = parseFloat(calc.getAttribute('data-roll-length-cm'));
    var rollPriceCents = parseInt(calc.getAttribute('data-roll-price'), 10);
    var moneyFormat = calc.getAttribute('data-money-format') || '${{amount}}';
    var unit = 'cm';
    var recommendedRolls = 0;

    if (!rollWidthCm || !rollLengthCm || !calculateBtn) return;

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, value);
    }

    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        var willShow = panel.hidden;
        panel.hidden = !willShow;
        toggleBtn.setAttribute('aria-expanded', String(willShow));
      });
    }

    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.getAttribute('data-wall-calc-unit');
        unitButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });

    calculateBtn.addEventListener('click', function () {
      var width = parseFloat(widthInput.value);
      var height = parseFloat(heightInput.value);
      if (!width || !height || width <= 0 || height <= 0) return;

      var widthCm = unit === 'in' ? width * 2.54 : width;
      var heightCm = unit === 'in' ? height * 2.54 : height;

      var strips = Math.ceil(widthCm / rollWidthCm);
      var rollsPerStrip = Math.ceil(heightCm / rollLengthCm);
      recommendedRolls = Math.max(1, strips * rollsPerStrip);

      if (countEl) countEl.textContent = recommendedRolls;
      if (sizeEl) sizeEl.textContent = rollLengthCm + 'x' + rollWidthCm + ' cm';
      if (priceEl) priceEl.textContent = formatMoney(rollPriceCents * recommendedRolls);
      if (resultEl) resultEl.hidden = false;
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!recommendedRolls) return;
        var block = calc.closest('.product-form__block');
        var qtyInput = block ? block.querySelector('[data-quantity-input]') : null;
        var cartBtn = block ? block.querySelector('[data-add-variant]') : null;
        if (qtyInput) qtyInput.value = recommendedRolls;
        if (cartBtn) cartBtn.click();
      });
    }
  });

  /* ---------- Roll quantity stepper + live Add to Cart price ---------- */
  document.querySelectorAll('[data-roll-qty]').forEach(function (qtyInput) {
    var block = qtyInput.closest('.product-form__block');
    if (!block) return;
    var addBtn = block.querySelector('[data-roll-add-btn]');
    var unitPriceCents = addBtn ? parseInt(addBtn.getAttribute('data-unit-price-cents'), 10) : 0;
    var moneyFormat = block.getAttribute('data-money-format') || '${{amount}}';
    var isAvailable = addBtn && !addBtn.disabled;

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, value);
    }

    function updatePrice() {
      if (!addBtn || !isAvailable || !unitPriceCents) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      addBtn.textContent = 'Add to Cart — ' + formatMoney(unitPriceCents * qty);
    }

    block.querySelectorAll('[data-qty-step]').forEach(function (stepBtn) {
      stepBtn.addEventListener('click', function () {
        var delta = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var current = parseInt(qtyInput.value, 10) || min;
        qtyInput.value = Math.max(min, current + delta);
        updatePrice();
      });
    });

    qtyInput.addEventListener('input', updatePrice);
  });

  /* ---------- Cart line quantity updates ---------- */
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
})();
